import React from 'react';

import { SVGComponentProps } from './svg.types';

const TaskHistorytaskAssigneeSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="16" cy="16" r="16" fill="#EEF1FC" />
        <path
          d="M10 20.949V19.943C10.0187 19.5765 10.1371 19.2221 10.3427 18.918C10.5482 18.614 10.8329 18.3719 11.166 18.218C14.3677 16.932 17.9423 16.932 21.144 18.218C21.4771 18.3719 21.7618 18.614 21.9673 18.918C22.1729 19.2221 22.2913 19.5765 22.31 19.943V20.949C22.3099 21.2186 22.2566 21.4856 22.1532 21.7347C22.0499 21.9837 21.8984 22.2099 21.7076 22.4004C21.5167 22.5909 21.2902 22.7419 21.041 22.8448C20.7917 22.9476 20.5246 23.0004 20.255 23H12.055C11.7854 23.0004 11.5183 22.9476 11.269 22.8448C11.0198 22.7419 10.7933 22.5909 10.6024 22.4004C10.4116 22.2099 10.2601 21.9837 10.1568 21.7347C10.0534 21.4856 10.0001 21.2186 10 20.949ZM16.155 9C15.4785 8.9998 14.8172 9.20021 14.2547 9.57589C13.6921 9.95156 13.2536 10.4856 12.9946 11.1105C12.7356 11.7354 12.6677 12.4231 12.7996 13.0866C12.9314 13.7501 13.2571 14.3596 13.7353 14.838C14.2136 15.3163 14.823 15.6422 15.4864 15.7742C16.1499 15.9063 16.8376 15.8386 17.4625 15.5798C18.0875 15.3209 18.6217 14.8826 18.9976 14.3202C19.3734 13.7577 19.574 13.0965 19.574 12.42C19.5741 11.9709 19.4858 11.5262 19.314 11.1113C19.1423 10.6964 18.8904 10.3193 18.5729 10.0018C18.2555 9.68417 17.8785 9.43223 17.4636 9.26035C17.0487 9.08847 16.6041 9 16.155 9Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default TaskHistorytaskAssigneeSVG;
